export const MEETING_LAYOUT = {
  header: { height: 64 },
  controls: { height: 80 },
  desktop: {
    pip: {
      width: 240,
      height: 135,
      aspectRatio: '16/9'
    }
  },
  mobile: {
    pip: {
      width: 135 / 1.5,
      height: 240 / 1.5,
      aspectRatio: '9/16'
    }
  }
} as const

export const VIDEO_CLASSES = {
  fullCover: '!absolute !inset-0 !h-full !w-full !object-cover',
  videoElement: '[&>video]:!absolute [&>video]:!inset-0 [&>video]:!h-full [&>video]:!w-full [&>video]:!object-cover'
} as const
